import React from 'react';
import styles from './News.module.scss';
import Card from '@components/Card';
import Excerpt from '@components/Excerpt';
import Img from 'gatsby-image';

export default function RecentPost({
  fields = {},
  frontmatter = {},
  excerpt: truncatedContent = ''
}) {
  const { slug } = fields;
  const { title, date, excerpt, featuredimage } = frontmatter;
  const content = (excerpt || truncatedContent)?.trim();

  if (!title || !slug || !content) {
    return null;
  }

  const image = !featuredimage ? null : (
    <Img
      fluid={[
        {
          ...featuredimage.childImageSharp.desktop,
          media: '(min-width: 821px)'
        },
        {
          ...featuredimage.childImageSharp.mobile,
          media: '(max-width: 820px)'
        }
      ]}
      alt=""
    />
  );

  return (
    <Card
      title={title}
      to={slug}
      thumbnail={image}
      linkText="Read more"
      className={styles.post}
      date={date}
    >
      <Excerpt
        text={content}
        maxLength={image ? 180 : 250}
      />
    </Card>
  );
}
